import { AppEnvironment, FirebaseEnvironment, StoreURL } from './entities/app_envirinment'

const firebase: FirebaseEnvironment = {
    apiKey: 'AIzaSyALb_ysVf10RnVVn_o6VoqnoWkz0cmY5Zg',
    authDomain: 'mc-app-genjirou.firebaseapp.com',
    projectId: 'mc-app-genjirou',
    storageBucket: 'mc-app-genjirou.firebasestorage.app',
    messagingSenderId: '862817600980',
    appId: '1:862817600980:web:04206e0fa49449c1aa8241',
    measurementId: 'G-7YHKBPXT6G',
}

const storeURL: StoreURL = {
    ios: 'https://apps.apple.com/app/6756248869',
    android: 'https://play.google.com/store/apps/details?id=jp.genjirou.members',
}

export const environment: AppEnvironment = {
    production: false,
    brandCode: 'genjirou',
    env: 'prd',
    firebase,
    hostingBaseURL: 'https://app.genjirou.jp',
    appScheme: 'genjirou-monogatari-app',
    storeURL,
}
